// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"85f80fb0","199":"2ac64012","821":"9b889357"}[chunkId] + ".chunk.js";
};